import styled, { css } from 'styled-components';
import Spacer from 'components/Spacer';
import { Heading } from 'components/Typography';
import { getThemeColor } from 'utils/styled';
import { DescriptionBodyProps } from './types';

const GRID_COLUMN_GAP_PX = 24;

export const GRID_AREA_THUMBNAIL = 'thumbnail';
export const GRID_AREA_HEADLINE = 'headline';
export const GRID_AREA_ACTIONS = 'actions';

export const makeDisableable = (opacity = 0.3) => css`
  ${Description}[data-disabled="true"] & {
    opacity: ${opacity};
  }
`;

export const Description = styled(Spacer).attrs({
  orientation: 'vertical',
  space: '10px',
})`
  color: ${getThemeColor('d1')};
`;

export const Header = styled.div`
  display: grid;
  grid-template-areas: '${GRID_AREA_THUMBNAIL} . ${GRID_AREA_HEADLINE} ${GRID_AREA_ACTIONS}';
  grid-template-columns: max-content 15px minmax(10px, 1fr) max-content;
  grid-template-rows: auto;
  width: 100%;
`;

export const HeaderActions = styled(Spacer).attrs({
  orientation: 'horizontal',
})`
  grid-area: ${GRID_AREA_ACTIONS};
  margin-left: ${GRID_COLUMN_GAP_PX}px;
`;

export const Body = styled(Heading).attrs({
  level: 2,
})<DescriptionBodyProps>`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ maxLines = 2 }) => maxLines};
  display: -webkit-box;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: normal;
`;

export const Footer = styled(Spacer).attrs(
  ({ align = 'center', space = '20px' }) => ({
    align,
    space,
    orientation: 'horizontal',
  }),
)``;
